import { useEffect, useState } from 'react'
import { AvailabilitySlot } from '../../../../../../../app/types/available_calendar'
import styles from './styles.module.css'
import moment from 'moment'

interface IExtendedSlotProps extends AvailabilitySlot {
  currentSelected: number[]
  onClick: Function
}

export function Slot({
  currentSelected,
  available,
  label,
  onClick,
  timeSlot: { fromTime, toTime },
}: IExtendedSlotProps) {
  const fromTimeTime = moment.utc(fromTime).valueOf()

  const [previouslySelected, setPreviouslySelected] = useState<number[]>()

  // use this to set the previously selected slot
  useEffect(() => {
    if (currentSelected.length) {
      setPreviouslySelected(
        currentSelected.map((dateString) => new Date(dateString).valueOf()),
      )
    }
  }, [])

  const fromTimeFormatted = new Date(fromTimeTime).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
    timeZone: 'UTC',
  })

  let clickHandler = () =>
    onClick({
      toTime: toTime,
      fromTime: fromTime,
    })

  let className = styles.slotCard

  if (previouslySelected?.includes(fromTimeTime)) {
    className += ` ${styles.previous}`
  } else if (!available) {
    clickHandler = () => {}
    className += ` ${styles.disabled}`
  }

  if (currentSelected.includes(fromTimeTime)) {
    className += ` ${styles.selected}`
  }

  return (
    <div onClick={clickHandler} className={className}>
      <div className={styles.slotCardTimeRange}>{label}</div>
    </div>
  )
}
